import { UserRole, RolePermissions } from '../types';

export const ROLES = {
  ADMIN: 'admin' as const,
  DESPACHADOR: 'despachador' as const,
  VISOR_REPORTES: 'visor_reportes' as const,
};

export const getRolePermissions = (role: UserRole): RolePermissions => {
  switch (role) {
    case ROLES.ADMIN:
      return {
        canManageUsers: true,
        canManageDrivers: true,
        canManageVehicles: true,
        canManageTrips: true,
        canViewReports: true,
        canExportData: true,
        canViewTabulador: true,
        canManageTabulador: true,
        canViewPendientesIKE: true,
      };
    case ROLES.DESPACHADOR:
      return {
        canManageUsers: false,
        canManageDrivers: false,
        canManageVehicles: false,
        canManageTrips: true,
        canViewReports: false,
        canExportData: false,
        canViewTabulador: false,
        canManageTabulador: false,
        canViewPendientesIKE: false,
      };
    case ROLES.VISOR_REPORTES:
      return {
        canManageUsers: false,
        canManageDrivers: false,
        canManageVehicles: false,
        canManageTrips: false,
        canViewReports: false,
        canExportData: true,
        canViewTabulador: true,
        canManageTabulador: false,
        canViewPendientesIKE: true,
      };
    default:
      return {
        canManageUsers: false,
        canManageDrivers: false,
        canManageVehicles: false,
        canManageTrips: false,
        canViewReports: false,
        canExportData: false,
        canViewTabulador: false,
        canManageTabulador: false,
        canViewPendientesIKE: false,
      };
  }
};

export const hasPermission = (userRole: UserRole, permission: keyof RolePermissions): boolean => {
  const permissions = getRolePermissions(userRole);
  return permissions[permission];
};

export const getRoleLabel = (role: UserRole): string => {
  switch (role) {
    case ROLES.ADMIN:
      return 'Administrador';
    case ROLES.DESPACHADOR:
      return 'Despachador';
    case ROLES.VISOR_REPORTES:
      return 'Visor de Reportes';
    default:
      return 'Usuario';
  }
};

export const getRoleColor = (role: UserRole): string => {
  switch (role) {
    case ROLES.ADMIN:
      return 'red';
    case ROLES.DESPACHADOR:
      return 'blue';
    case ROLES.VISOR_REPORTES:
      return 'green';
    default:
      return 'gray';
  }
};
